/* unplugin-vue-components disabled */import script from "./PhoneBind.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneBind.vue?vue&type=script&setup=true&lang=js"

import "./PhoneBind.vue?vue&type=style&index=0&id=75ee0cd6&lang=scss"

const __exports__ = script;

export default __exports__